<template>
    <div>
        <navigation-bar Close/>
        <div class="qr-code main">
            <el-row type="flex" justify="end">
                <el-col :span="4" class="text-right">
                    <el-button @click="$router.push({name: 'EditQrCode'})" type="text" class="pr-3 pl-3"><img
                            src="@/assets/images/edit_black.svg" alt="編輯" style="width: 22px;"></el-button>
                </el-col>
            </el-row>
            <div class="qr-block">
                <div class="avatar">
                    <div class="image_empty" v-if="avatar===''"/>
                    <el-image :src="avatar" fit="cover" lazy v-else/>
                </div>
                <div class="code">
                    <p class="name">{{this.nickname}}</p>
                    <vue-qrcode id='qrcode' v-if="agree" v-model="vcard"/>
                    <div v-else class="disagree">
                        <img src="@/assets/images/dialog_warning.svg">
                        <p>尚未同意使用條款<br>無法使用此功能喔</p>
                    </div>
                </div>
                <p class="mt-3">掃描條碼分享個人聯絡資訊給他人</p>
            </div>
            <p class="text-center">
                <el-checkbox v-model="agree">我已同意<span class="blue" @click="$router.push({name: 'QrCodePrivacy'})">使用QR通訊錄功能暨使用條款</span></el-checkbox>
            </p>
            <div class="footer-button">
                <el-button v-show="false" @click="openedShare = true" round>分享</el-button>
                <!-- <el-button type="primary" @click="openedPrivacy = true" round>保存</el-button> -->
                <el-button type="primary" v-show="false" @click="saveOnDevice" round>保存</el-button>
            </div>
            <popup-model :opened.sync="openedShare">
                <div class="popup">
                    <img src="@/assets/images/add_address.svg">
                    <p class="description">QR通訊錄讓好友直接<br>將您的通訊加入手機連絡簿</p>
                    <p class="text">請注意，此分享會讓他人獲得您設置的個人聯絡資訊，請謹慎使用。</p>
                    <el-row type="flex" justify="start" class="icon-group">
                        <el-col :span="6">
                            <div class="icon-block">
                                <Logo/>
                            </div>
                            <span>OIN好友</span>
                        </el-col>
                        <el-col :span="6">
                            <div class="icon-block">
                                <img src="@/assets/images/icon_Line.svg">
                            </div>
                            <span>Line</span>
                        </el-col>
                        <el-col :span="6">
                            <div class="icon-block">
                                <img src="@/assets/images/icon_Messenger.svg">
                            </div>
                            <span>Message</span>
                        </el-col>
                    </el-row>
                </div>
            </popup-model>
            <popup-model :opened.sync="openedSave">
                <div class="popup">
                    <img src="@/assets/images/dialog_question.svg">
                    <p class="description">將QR通訊錄QRCODE另存成圖檔</p>
                    <img style="width: 144px" src="@/assets/images/test_qrcode.svg" alt="">
                    <p class="text text-center">下載條碼 JPG│PNG│SVG</p>
                </div>
            </popup-model>
        </div>
    </div>

</template>

<script>
    import PopupModel from '@/views/more/qrCode/components/popupModel.vue'
    import VueQrcode from 'vue-qrcode'
    import Logo from "@/components/Logo";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    export default {
        name: "QrCode",
        components: { PopupModel, VueQrcode , Logo},
        data() {
            return {
                nickname: '',
                avatar: '',
                agree: true,
                openedPrivacy: false,
                openedSave: false,
                openedShare: false,
                vcard: 'empty'
            }
        },
        created() {
            this.getUserData()
        },
        mounted() {
            this.getContactInfo()
        },
        methods: {
            saveOnDevice: function () {
                var params = {data: document.getElementById("qrcode").src};
                window.imageSaver.saveBase64Image(params,
                    function (filePath) {
                        alert('保存成功')
                    },
                    function (msg) {
                        console.error(msg);
                    }
                );
            },
            createVCard: function (array) {
                let vcardStr = "BEGIN:VCARD\nVERSION:3.0\n"
                if (array.length <= 0) {
                    this.vcard = vcardStr + 'END:VCARD';
                } else {
                    array.forEach(function (vcardModel) {
                        switch (vcardModel.tag) {
                            case 'FN':
                            case 'ORG':
                            case 'TITLE':
                            case 'BDAY':
                            case 'N':
                                vcardStr += "\n" + vcardModel.tag + ":" + vcardModel.value
                                break;
                            case 'ADR': {
                                let address = vcardModel.city + vcardModel.district + vcardModel.street
                                vcardStr += "\n" + vcardModel.tag + ";TYPE=" + vcardModel.title + ":" + address
                                break;
                            }
                            case 'EMAIL':
                                vcardStr += "\n" + vcardModel.tag + ";TYPE=" + vcardModel.title + ";PREF;INTERNET:" + vcardModel.value
                                break;
                            case 'TEL':
                                vcardStr += "\n" + vcardModel.tag + ";TYPE=" + vcardModel.title + ",VOICE:" + vcardModel.value
                                break;
                            case 'URL':
                                vcardStr += "\n" + vcardModel.tag + ";TYPE=" + vcardModel.title + ":" + vcardModel.value
                                break;
                            case 'Social': case 'Msn':
                                vcardStr += "\n" + "X-" + vcardModel.title + ":" + vcardModel.value
                                break;
                        }
                    })
                    vcardStr += '\nEND:VCARD';
                    this.vcard = vcardStr;
                }
            },
            getUserData: function () {
                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                this.avatar = userData.picture
                this.nickname = userData.nickName
            },
            getContactInfo: function () {
                this.$http.fetchWithAuth`GetUserContact${{}}
                ${json => {
                    if (json.status) {
                        var vcardArr = [];

                        //如果姓名是空的，就填註冊的姓名
                        let name = json.data.firstName + json.data.lastName;
                        if (name === undefined || name === '') {
                            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                            const userData = getCryptoUserInfo();
                            vcardArr.push({tag: 'N', title: '', value: userData.nickName});
                        } else {
                            vcardArr.push({tag: 'N', title: '', value: json.data.firstName + json.data.lastName});
                        }


                        vcardArr.push({tag: 'ORG', title: '', value: json.data.company});
                        if (json.data.isShowBirthday !== 0) {
                            vcardArr.push({tag: 'BDAY', title: '', value: json.data.birthday});
                        }

                        let hasTel = false; //是否有電話資料？

                        json.data.contactList.forEach(function (item) {
                            switch (item.type) {
                                case 1: {
                                    vcardArr.push({tag: 'TEL', title: item.title, value: item.content});
                                    hasTel = true;
                                    break;
                                }
                                case 2:
                                    vcardArr.push({tag: 'EMAIL', title: item.title, value: item.content});
                                    break;
                                case 3:
                                    vcardArr.push({tag: 'URL', title: item.title, value: item.content});
                                    break;
                                case 4:
                                    vcardArr.push({
                                        tag: 'ADR',
                                        title: item.title,
                                        value: item.address,
                                        city: item.city,
                                        district: item.township,
                                        street: item.address
                                    });
                                    break;
                                case 5:
                                    vcardArr.push({tag: 'Social', title: item.title, value: item.content});
                                    break;
                                case 6:
                                    vcardArr.push({tag: 'Msn', title: item.title, value: item.content});
                                    break;
                            }
                        })

                        //電話爲空的話就帶註冊時的電話
                        if (!hasTel) {
                            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                            const userData = getCryptoUserInfo();
                            vcardArr.push({tag: 'TEL', title: 'voice', value: userData.phone});
                        }

                        this.createVCard(vcardArr);
                    }
                }}`;
            }
        }
    }
</script>
<style lang="less" scoped src="../../../less/scan.less"/>
<style lang="less" scoped src="../../../less/personalInfo.less"/>